import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ReactComponent as CloseBtn } from '../../../assets/icons/close.svg';
import PostLoginGetApi from '../../../components/Api/PostLoginGetApi';
import PostLoginPostApi from '../../../components/Api/PostLoginPostApi';
import BlackButton from '../../../components/BlackButton';
import init from '../AccessControl/Check';

const EditRole = () => {
    const pageName = "Role Update";
    const isAccess = init(pageName);

    const navigate = useNavigate();
    const params = useParams();

    const [id, setId] = useState("");
    const [roleName, setRoleName] = useState("");
    useEffect(() => {
        if (params?.id === "" || isNaN(params?.id) === true) {
            // Redirect to lists
            return;
        }

        // Check
        const id = params?.id;
        PostLoginGetApi("manage/role/" + id, "", 3).then((responseJSON) => {

            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    if (responseData.data?.is_default === 1) {
                        toast.error("You can not allowed to change any default role.");
                        navigate("/dashboard/role");
                        return;
                    }

                    setId(id);
                    setRoleName(responseData.data?.name);
                    return;
                }

                toast.error(responseData["messages"].toString() + "");
                navigate("/dashboard/role");
                return;
            }

            navigate("/dashboard/role");
            return;

        }).catch((error) => {
            console.log(error);
        });

    }, [navigate, params]);



    const onSubmit = (e) => {
        e.preventDefault();

        if (roleName === "") {
            toast.error("Please enter role name");
            return;
        }

        PostLoginPostApi("manage/role/" + id, JSON.stringify({ name: roleName }), 3, 0, 2).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    toast.success("Role update successfully.");
                    navigate("/dashboard/role");
                    return;
                }

                toast.error(responseData["message"].toString() + "");
            }
        }).catch((error) => {
            console.log(error);
        });
    }

    if (isAccess === false) {
        return (<>
            <table className="custom-details-table w-full mt-0 mb-2">
                <tbody>
                    <tr>
                        <td className="font-semibold text-base">
                            You do not have any access !
                        </td>
                    </tr>
                </tbody>
            </table>
        </>);
    }

    return (
        <div className="font-medium min-h-[100vh] w-[100%] h-[100%] custom-container-left custom-scroll-auto">
            <header className="p-4 border-b-2 border-dark-white mb-[60px]">
                <Link to="/dashboard/role"><CloseBtn className="float-left" /></Link>
                <p className="text-center">Edit Role</p>
            </header>
            <main className="max-w-2xl m-auto">

                <h1 className="text-xl">Role Name</h1>
                <form onSubmit={onSubmit}>
                    <div className="my-[15px]">
                        <input type="text" name="category_name" placeholder="Enter Role Name *" value={roleName}
                            onChange={(event) => setRoleName(event.currentTarget.value)} className="w-full mb-2.5 rounded border-solid border border-dark-white placeholder:text-ash" required />
                    </div>
                    <BlackButton name="Submit" />
                </form>

            </main>
        </div>
    );
};

export default EditRole;